import React from "react";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const RadioButton = ({ value, label, ...props }) => {
  return label ? (
    <FormControlLabel control={<Radio value={value} {...props} />} value={value} label={label} />
  ) : (
    <Radio value={value} {...props} />
  );
};

RadioButton.propTypes = {
  /*
   * Label del radiobutton
   */
  label: PropTypes.string,
  /*
   * Valor del radiobutton
   */
  value: PropTypes.string.isRequired,
};

export default RadioButton;
